import { Dialog, DialogProps } from '@mui/material';
import { FeedbackLabelType } from 'v2/core/entities/feedback';
import { CreateOrUpdateLabelSuccessDialogContent } from './CreateOrUpdateLabelSuccessDialogContent';

interface CreateOrUpdateLabelSuccessModalProps
  extends Omit<DialogProps, 'onClose'> {
  action: 'create' | 'update';
  label: {
    type: FeedbackLabelType.Entity | FeedbackLabelType.Reason;
    name: string;
  };
  footerNode?: React.ReactElement;
  onClose: () => void;
}

export const CreateOrUpdateLabelSuccessModal = ({
  action,
  open,
  onClose,
  footerNode,
  label,
}: CreateOrUpdateLabelSuccessModalProps) => {
  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xs"
      onClose={onClose}
      PaperProps={{ elevation: 3 }}
    >
      <CreateOrUpdateLabelSuccessDialogContent
        action={action}
        label={label}
        onClose={onClose}
        footerNode={footerNode}
      />
    </Dialog>
  );
};
